import { CheckCircleOutlined, HighlightOff, NotificationsOff, QuestionMarkOutlined } from '@mui/icons-material'
import { Grid, useTheme } from '@mui/material'
import { GridCellParams } from '@mui/x-data-grid-pro'

import useSharedStyles from '../../../../utils/shared.styles'

const AlertTablePanelResponse = (cellParams: GridCellParams<DeviceAlertPanelTableRow, string>) => {
  const theme = useTheme()
  const sharedClasses = useSharedStyles

  const cellValue = cellParams.value ?? 'unknown'

  const { IconComponent, iconColor, text } = {
    ack: { IconComponent: CheckCircleOutlined, iconColor: theme.palette.success.main, text: 'Acknowledged' },
    decline: { IconComponent: HighlightOff, iconColor: theme.palette.text.disabled, text: 'Declined' },
    test: { IconComponent: NotificationsOff, iconColor: theme.palette.error.main, text: 'Ignored' },
    unknown: { IconComponent: QuestionMarkOutlined, iconColor: theme.palette.text.disabled, text: 'Responded' },
  }[cellValue] ?? { IconComponent: QuestionMarkOutlined, iconColor: theme.palette.text.disabled, text: 'Responded' }

  return (
    <Grid container={true} sx={[sharedClasses.centerContentVertical, { gap: 0.5 }]}>
      <Grid
        sx={{
          display: 'flex',
        }}
      >
        <IconComponent htmlColor={iconColor} />
      </Grid>
      <Grid>{text}</Grid>
    </Grid>
  )
}

export default AlertTablePanelResponse
